/* eslint-env browser */

/**
 * GSAP Scroll Animations for Article Posts
 *
 * Animations:
 * 1. Hero parallax - Feature image moves slower than scroll
 * 2. Hero desaturation - Image fades to grayscale as you scroll past
 * 3. Section reveals - Headings and paragraphs fade in with upward motion
 * 4. Pull quote animation - Blockquotes slide in from left
 *
 * Only runs on article posts, not podcasts.
 */

(function (window, document) {
    'use strict';

    // Check if GSAP and ScrollTrigger are available
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    // Only run on article posts (not podcasts). Ghost's body_class adds a
    // tag-{slug} class per post tag. Articles without a feature image have
    // no .article-hero, so the hero animations below guard on it themselves.
    function isArticlePost() {
        var body = document.body.classList;
        return body.contains('post-template') && !body.contains('tag-automagic');
    }

    if (!isArticlePost()) {
        return;
    }

    // Respect user's motion preferences
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    // DOM Elements
    var heroContainer = document.querySelector('.article-hero');
    var heroImg = document.querySelector('.article-hero .hero-image');
    var headings = document.querySelectorAll('.gh-content > h2');
    var paragraphs = document.querySelectorAll('.gh-content > p');
    var blockquotes = document.querySelectorAll('.gh-content > blockquote');

    // Animation 1: Hero Parallax (subtle: yPercent 15)
    function initHeroParallax() {
        if (!heroImg) return;

        gsap.to(heroImg, {
            yPercent: 15,
            ease: 'none',
            scrollTrigger: {
                trigger: heroContainer,
                start: 'top top',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    // Animation 2: Hero Desaturation
    function initHeroDesaturation() {
        if (!heroImg) return;

        gsap.to(heroImg, {
            filter: 'grayscale(100%)',
            ease: 'none',
            scrollTrigger: {
                trigger: heroContainer,
                start: '30% top',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    // Animation 3: Section Reveals (H2 headings) - subtle: y 4, duration 0.2
    function initSectionReveals() {
        if (!headings.length) return;

        headings.forEach(function (heading) {
            gsap.from(heading, {
                y: 4,
                opacity: 0,
                duration: 0.2,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: heading,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            });
        });
    }

    // Animation 4: Paragraph Reveals - subtle: y 4, duration 0.2
    function initParagraphReveals() {
        if (!paragraphs.length) return;

        paragraphs.forEach(function (paragraph) {
            gsap.from(paragraph, {
                y: 4,
                opacity: 0,
                duration: 0.2,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: paragraph,
                    start: 'top 95%',
                    toggleActions: 'play none none none'
                }
            });
        });
    }

    // Animation 5: Pull Quote Animation (Blockquotes) - x -15, duration 0.4
    function initPullQuotes() {
        if (!blockquotes.length) return;

        blockquotes.forEach(function (quote) {
            gsap.from(quote, {
                x: -15,
                opacity: 0,
                duration: 0.4,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: quote,
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                }
            });
        });
    }

    // Initialize all animations
    function init() {
        initHeroParallax();
        initHeroDesaturation();
        initSectionReveals();
        initParagraphReveals();
        initPullQuotes();
    }

    init();

})(window, document);
